import { useState } from 'react';
import { Icon } from '@/lib/icon';
import { RunJobSheet } from './RunJobSheet';
import styles from './RunJobCard.module.css';

export interface RunJobCardProps {
  templateId: string;
  title: string;
  description?: string | null;
  icon?: string | null;
  prefillMemberId?: string;
}

export function RunJobCard({
  templateId,
  title,
  description,
  icon,
  prefillMemberId,
}: RunJobCardProps) {
  const [open, setOpen] = useState(false);
  const [everOpened, setEverOpened] = useState(false);

  function handleOpen() {
    setEverOpened(true);
    setOpen(true);
  }

  return (
    <>
      <button type="button" className={styles.card} onClick={handleOpen}>
        {icon ? (
          <span className={styles.icon} aria-hidden="true">
            <Icon iconRef={icon} size={20} />
          </span>
        ) : null}
        <span className={styles.body}>
          <span className={styles.title}>{title}</span>
          {description ? <span className={styles.desc}>{description}</span> : null}
        </span>
        <span className={styles.arrow} aria-hidden="true">
          →
        </span>
      </button>

      {everOpened && (
        <RunJobSheet
          open={open}
          onOpenChange={setOpen}
          templateId={templateId}
          prefillMemberId={prefillMemberId}
        />
      )}
    </>
  );
}
